import React, { useCallback } from 'react'
import { Box, Button, Flex, Spacer, Tag, useDisclosure } from '@chakra-ui/react'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'

import FilterConfig from '../../../components/features/Wizard/FilterConfig/FilterConfig'
import { filterColours } from '../../../services/decoders/blueprintDecoder'
import { useFetchReportSections } from '../hooks/useFetchStructureQuery'

const columnSizes = ['5%', '20%', '50%', '20%']

const SetupFilters = observer(() => {
  const {
    wizardStore: { sourceId, selectedSection, setSelectedSection },
  } = rootStore

  const { reportSections } = useFetchReportSections(sourceId)

  const { onOpen, onClose, isOpen } = useDisclosure()

  const handleEditClick = useCallback(
    section => {
      onOpen()
      setSelectedSection(section)
    },
    [onOpen, setSelectedSection],
  )
  return (
    <Box>
      <Flex flexDir="column">
        <Row
          h="40px"
          borderBottom="1px solid rgba(0, 0, 0, .1)">
          <Col
            width={columnSizes[0]}
            minW="50px">
            {' '}
          </Col>
          <Col
            width={columnSizes[1]}
            minW="240px"
            fontWeight="bold">
            Section
          </Col>
          <Col
            width={columnSizes[2]}
            minW="20px"
            fontWeight="bold">
            FilterIDs
          </Col>
          <Spacer />
          <Col
            width={columnSizes[3]}
            fontWeight="bold">
            'Left-menu filters'
          </Col>
        </Row>
        {reportSections?.map((section, index) => {
          return (
            <Row
              padding="5px"
              h="40px"
              key={section.id}>
              <Col
                width={columnSizes[0]}
                minW="50px">
                <Button
                  size="xs"
                  colorScheme="orange"
                  onClick={() => handleEditClick(section)}>
                  Edit
                </Button>
              </Col>
              <Col
                width={columnSizes[1]}
                minW="240px">
                {index + 1}. {section.title}
              </Col>
              <Col width={columnSizes[2]}>
                <Flex>
                  {section.filters?.map(filterId => (
                    <Tag
                      fontWeight="bold"
                      mr={2}
                      key={filterId}
                      background={filterColours[filterId]}>
                      {filterId}
                    </Tag>
                  ))}
                </Flex>
              </Col>
              <Spacer />
              <Col width={columnSizes[3]}>
                <Box> - </Box>
              </Col>
            </Row>
          )
        })}
      </Flex>
      <FilterConfig
        section={selectedSection}
        onClose={onClose}
        isOpen={isOpen}
      />
    </Box>
  )
})

const Row = ({ children, ...rest }) => <Flex {...rest}>{children}</Flex>

const Col = ({ children, ...rest }) => (
  <Box
    {...rest}
    padding="12px">
    {children}
  </Box>
)

SetupFilters.propTypes = {}

export default SetupFilters
